module.exports = {
  CONTACT_US_DECISION_TREE_NODE: "Contact us decision tree node",
  CONTACT_US_STANDARD_SOLUTION: "Contact us standard solution",
  CONTACT_US_STANDARD_EXPANDED_SOLUTION: "Contact us standard expanded solution",
  CONTACT_US_REBOUND_SOLUTION: "Contact us rebound solution",
  CONTACT_US_MANUFACTURER_SOLUTION: "Contact us manufacturer solution",
  CONTACT_US_NON_ELECTRICAL_SOLUTION: "Contact us non-electrical Solution",
  CONTACT_US_REFUNDS_SOLUTION: "Contact us refunds solution",
  CONTACT_US_DELIVERY_SOLUTION: "Contact us delivery solution",
  CONTACT_US_PROBLEMS_WITH_PRODUCT_GUARANTEES_AND_PROTECT_PLUS: "Contact us guarantees and protect plus",
  CONTACT_US_PRODUCT_STOCK_SOLUTION: "Contact us product stock solution",
  CONTACT_US_PRODUCT_STOCK_OTHER_SOLUTION: "Contact us product stock other solution",
  CONTACT_US_PRODUCT_STOCK_TOOL_SOLUTION: "Contact us product stock tool solution",
  CONTACT_US_PRODUCT_STOCK_PRICE_MATCH: "Contact up product stock price match",
  CONTACT_US_HELP_ORDER_SOLUTION: "Contact us help order solution",
  CONTACT_US_REPAIR_UPDATE_ELECTRICAL_ITEM_SOLUTION: "Contact us repair update on electrical item",
  CONTACT_US_PRODUCT_STOCK_CHECK_IN_STORE_SOLUTION: "Contact us product check in store solution",
};
